// @flow
import Loadable from '@src/components/Loadable';

const NotFoundLoader = Loadable({
  loader: () => import('./404'),
});

export default NotFoundLoader;
